import { render, staticRenderFns } from "./LastYearConsumptionWidget.global.vue?vue&type=template&id=5af25274&lang=pug&"
import script from "./LastYearConsumptionWidget.global.vue?vue&type=script&lang=ts&"
export * from "./LastYearConsumptionWidget.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports